import React, {useState} from 'react';
import useInputState from '../hooks/forms/useInputState';
import RequestTokenForm from './RequestTokenForm';
import VerifyTokenForm from './VerifyTokenForm';
import ConfirmPasswordForm from './ConfirmPasswordForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import Button from 'react-bootstrap/Button';


const ForgotPasswordForm = (props) => {
    const {email, setEmail, resetStep, editResetStep, tryLogin} = props;
    const [token, setToken] = useInputState('');

    const backToLogin = () => {
        tryLogin(true);
    }

    return (
        <>
         { resetStep=='email' && <RequestTokenForm 
                                email={email} 
                                setEmail={setEmail} 
                                changeStep={editResetStep} 
                                /> }
         { resetStep=='token' && <VerifyTokenForm 
                                token={token} 
                                email={email} 
                                setToken={setToken} 
                                changeStep={editResetStep} 
                                /> }
         { resetStep=='password' && <ConfirmPasswordForm 
                                token={token} 
                                email={email}  
                                tryLogin={tryLogin}
                                changeStep={editResetStep} 
                                /> }
            <hr className="my-4" />
            <p className="text-center">
                <FontAwesomeIcon icon={faArrowLeft} height="16" width="16" />
                <Button variant="link" onClick={backToLogin}>Login</Button>
            </p>
        </>
    );
}

export default ForgotPasswordForm;